import React from 'react'
import PageBody from '../../../components/pagebody/PageBody'
import FileUpload from '../../../components/fileupload/FileUpload'
import Button from '../../../components/button/Button'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setUploadedFile } from './FileShareSlice'
import { uploadFile } from './FileShareSaga'
import styles from './FileShare.styles'
import Loadable from '../../../components/loadable/Loadable'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { FILE_SHARE_LOADING_STATE, FILE_SHARE_MESSAGE_MAP } from './constants'

export default function FileShare() {

    useGarbageCollector(componentKey);
    const { uploadedFile, loadingState } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    const handleFileUpload = () => {
        if (uploadedFile) {
            dispatch(uploadFile(uploadedFile));
        }
    }

    const allowedFileTypes = ['.txt', '.doc', '.docx', '.xlsx', '.xls', '.csv', '.pdf'];

    const handleUploadedFileChange = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            if (file) {
                dispatch(setUploadedFile(file));
            }
        } else {
            dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
        }
        event.target.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            dispatch(setUploadedFile(file));
            
        } else {
            dispatch(addNotifications({ 
                heading: "File format not supported", 
                message: `Invalid file format. Please upload a ${allowedFileTypes.join(", ")} file.` 
            }));
        }
    };

    return (
        <PageBody>
            <Loadable isNewLoadable={true} currentState={loadingState.state} loadingStates={[FILE_SHARE_LOADING_STATE.LOADING]} messageMap={FILE_SHARE_MESSAGE_MAP} >
                <div style={styles.mainContainer}>
                    <FileUpload
                        uploadedFile={uploadedFile}
                        onDropCb={handleDrop}
                        allowedFileType={allowedFileTypes}
                        onInputChangeCb={handleUploadedFileChange}
                    />

                    {uploadedFile && 
                        <div style={styles.actionButton}>
                            <Button onClickCb={handleFileUpload}>Next</Button>
                        </div>
                    }
                </div>
            </Loadable>
        </PageBody>
  )
}